import { Skeleton, Box } from '@mui/material';
import { CustomDashboardConfigContext } from 'contexts/CustomDashboardConfig';
import { defaultConfig } from 'themeConfig';

import { useContext, useEffect, useState } from 'react';
import { useIntl } from 'react-intl';

const Logo = () => {
    const intl = useIntl();
    const defaultLogo = defaultConfig.defaultLogo;
    const { dashboardConfig } = useContext(CustomDashboardConfigContext);
    const [logoSrc, setLogoSrc] = useState<string>('');

    // Dashboard config, cuando no tiene configuración es {} y cuando tiene configuración es un objeto con las propiedades de la configuración
    useEffect(() => {
        if (dashboardConfig?.logoSrc?.length > 0) {
            setLogoSrc(dashboardConfig?.logoSrc);
        }
        if (dashboardConfig && !dashboardConfig?.logoSrc) {
            setLogoSrc(defaultLogo);
        }
    }, [dashboardConfig]);

    return (
        <Box
            maxHeight={'40px'}
            minHeight={'40px'}
            overflow={'hidden'}
            display={'flex'}
            flexDirection={'column'}
            justifyContent={'center'}
            alignItems={'flex-start'}
        >
            {logoSrc ? (
                <img
                    src={logoSrc}
                    alt={intl.formatMessage({ id: 'INICIO' })}
                    style={{
                        maxWidth: '170px',
                        maxHeight: '40px',
                        width: 'auto',
                        height: 'auto',
                        objectFit: 'contain'
                    }}
                    onError={(e) => {
                        e.currentTarget.src = defaultLogo;
                    }}
                />
            ) : (
                <Skeleton variant="rounded" width={180} height={35} animation={'wave'} />
            )}
        </Box>
    );
};

export default Logo;
